import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    adminLaboratoryAuth: false,
    token: '',
    loginError: '',
    loginLoading: false,
    LaboratoryId: 0,
  },
  reducers: {
    fetchLaboratoryUserLogin: (state) => {
      // let data = localStorage.getItem('adminPharmacyAuth')
      // let parsedData = JSON.parse(data)
      // state.adminPharmacyAuth = parsedData
      let data = localStorage.getItem('adminLaboratoryAuth')
      let token = localStorage.getItem('adminLaboratoryToken')
      const laboratoryExpirationDate = localStorage.getItem('laboratoryExpirationDate')
      if (!token || !laboratoryExpirationDate || !data) {
        return { ...state, adminLaboratoryAuth: false, token: '' } // Set to false instead of null
      }
      const now = new Date()
      const expiry = new Date(laboratoryExpirationDate)
      if (now >= expiry) {
        localStorage.removeItem('adminLaboratoryAuth')
        localStorage.removeItem('adminLaboratoryToken')
        localStorage.removeItem('laboratoryExpirationDate')
        return { ...state, adminLaboratoryAuth: false, token: '' } // Set to false instead of null
      }
      let parsedData = JSON.parse(data)
      return { ...state, adminLaboratoryAuth: parsedData, token: token } // Return new state object
    },
    userLaboratoryLogin: (state) => {
      state.loginLoading = true
      state.loginError = ''
    },
    userLaboratoryLoginSuccess: (state, { payload: { payload } }) => {
      let data = JSON.stringify(payload?.data)
      state.LaboratoryId = payload?.data?.id
      const now = new Date()
      const laboratoryExpirationDate = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000)
      localStorage.setItem('adminLaboratoryAuth', data)
      localStorage.setItem('adminLaboratoryToken', payload.data.access_token)
      localStorage.setItem('laboratoryExpirationDate', laboratoryExpirationDate.toISOString())
      state.loginLoading = false
      state.adminLaboratoryAuth = payload.data
      state.token = payload.data.access_token
    },
    userLaboratoryLoginFailed: (state, { payload }) => {
      state.token = '' // Use an empty string instead of null for consistency
      state.loginLoading = false
      state.loginError = payload.message
    },

    adminLaboratoryLogoutFunc: (state) => {
      localStorage.removeItem('adminLaboratoryAuth')
      localStorage.removeItem('adminLaboratoryToken')
      localStorage.removeItem('laboratoryExpirationDate')
      return { ...state, adminLaboratoryAuth: false, token: '' }
    },
  },
})

export const {
  adminLaboratoryLogoutFunc,
  fetchLaboratoryUserLogin,
  userLaboratoryLogin,
  userLaboratoryLoginSuccess,
  userLaboratoryLoginFailed,
} = slice.actions

export default slice.reducer
